import { useForm, useStore } from '@tanstack/react-form'
import { FF } from 'ui/components'
import { CompanySelect, Select } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'

import { useClientPortalReportContext } from '../../context/reportContext'

import { s } from './styles'

export const Filter = () => {
  const {
    data: {
      form: { status, relationshipId },
      statusOptions
    },
    routeApi
  } = useClientPortalReportContext()

  const navigate = routeApi.useNavigate()
  const formApi = useForm({
    defaultValues: { status, relationshipId }
  })

  const clearForm = () => {
    formApi.reset()
    navigate({ to: '.', search: undefined, resetScroll: false, replace: true })
  }

  return (
    <FilterPanel isDirty={useStore(formApi.store, (s) => s.isDirty) || false} onReset={clearForm} expanded={false}>
      <s.Columns>
        <s.Column>
          <formApi.Field
            name="status"
            listeners={{
              onChange: ({ value }) => {
                navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, status: value }) })
                return undefined
              }
            }}
            children={(field) => (
              <FF
                label="Status"
                field={field}
                input={(inputProps) => <Select {...inputProps} data={statusOptions} />}
              />
            )}
          />
        </s.Column>
        <s.Column>
          <formApi.Field
            name="relationshipId"
            listeners={{
              onChange: ({ value }) => {
                navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, relationshipId: value }) })
                return undefined
              }
            }}
            children={(field) => (
              <FF
                label="Company"
                field={field}
                input={(inputProps) => (
                  <CompanySelect
                    {...inputProps}
                    hideMyCompaniesFilter
                    emptyOption={{ label: 'Clear filter', value: null }}
                  />
                )}
              />
            )}
          />
        </s.Column>
      </s.Columns>
    </FilterPanel>
  )
}
